export enum EquipmentsActions {
    FETCH_EQUIPMENTS = 'FETCH_EQUIPMENTS',
    FETCH_DATACENTERS = 'FETCH_DATACENTERS',
    DELETE_EQUIPMENT = 'DELETE_EQUIPMENT',
    UPDATE_EQUIPMENT = 'UPDATE_EQUIPMENT',
    CREATE_EQUIPMENT = 'CREATE_EQUIPMENT',
    FETCH_PARAMETERS = 'FETCH_PARAMETERS',
}
